import React from 'react';
import { Box } from '@mui/material';
import { WhatsApp } from '@mui/icons-material';
import { Button } from '@sm-dashboard/ui-components';

const WhatsAppSupportButton = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
      <Button
        color="success"
        startIcon={<WhatsApp />}
        onClick={() => window.open('https://wa.me/972533753331', '_blank', 'noopener,noreferrer')}
        fullWidth={false}
      >
        תמיכה
      </Button>
    </Box>
  );
};

export default WhatsAppSupportButton;
